import { render, staticRenderFns } from "./_issue.vue?vue&type=template&id=0b69bc38&scoped=true"
import script from "./_issue.vue?vue&type=script&lang=js"
export * from "./_issue.vue?vue&type=script&lang=js"
import style0 from "./_issue.vue?vue&type=style&index=0&id=0b69bc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b69bc38",
  null
  
)

export default component.exports